module.exports = __webpack_public_path__ + "img/BfA_gue.19cef65d.png";